import React, { ReactElement } from 'react'
import Link from 'next/link'

import { flex } from 'styled-system/patterns'
import { MindfulChefLogo } from '@mindfulchefuk/design-system/Logos/MindfulChefLogo'
import { OnboardingCartNavButton } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingCartNavButton'

export const OnboardingChooseRecipesNavigation = (): ReactElement => {
  return (
    <div
      className={flex({
        background: 'salt',
        px: { base: 6, lg: 12 },
        minHeight: { base: 20, lg: 24 },
        alignItems: 'center',
      })}
    >
      <Link href="/">
        <MindfulChefLogo color="aubergine" height={{ base: 24, md: 28 }} />
      </Link>

      <OnboardingCartNavButton />
    </div>
  )
}
